module.exports = __webpack_public_path__ + "img/logo.0de0df96.png";